import React, { Component, Fragment } from 'react';
import './manageTopic.scss';
import Switch from 'react-switch';
import Modal from 'react-bootstrap/Modal';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { clearErrors } from '../../../../ActionCreators/errorAction';
import { showWarning, closeSubModal } from '../../../../ActionCreators/AdminAction/accountAction';
import { publishSkillpath, editSkillpath, resetSKillpods, getSkillPodDetails, getSkillPods, savedSkillPod, updatedSkillPod, changeSkillPodStatus, reorderSkillPods, reorderedSkillPods } from '../../../../ActionCreators/AdminAction/manageSkillpathAction';
import Snackbar from '@mui/material/Snackbar';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { BallBeat, TopicLoader } from '../../../../Loader/loader';
import WarningModal from '../../../../utils/Expiremodal/warningModal';


class ManageTopic extends Component {

    state = {
        edit: false,
        isEdit: false,
        checked: false,
        isAddTopic: false,
        imageUrl: '/images/empty-image.svg',
        name: '',
        image: '',
        show: false,
        chars_left: 75,
        maxChar: 75,
        isLoading: false,
        update: false,
        date: '',
        isFocused: false,
        isChangeImage: false,
    }

    componentDidMount = async () => {
        console.log(this.props.history.location.state)
        this.setState({
            skillPathId: this.props.customPathId || this.props.history.location.state?.id,
            draft: this.props.history.location.state?.status,
            createSkillpath: this.props.plans?.features?.filter(el => el.feature === 'Create custom learning paths')[0]?.allow
        })

        await this.props.resetSKillpods();
        await this.props.getSkillPodDetails(this.props.customPathId || this.props.history?.location?.state?.id);
        await this.props.getSkillPods(this.props.customPathId || this.props.history?.location?.state?.id);
    }


    addTopic = (el, val) => {
        if (el !== null) {
            this.setState({
                name: el.title,
                image: el.image,
                imageUrl: el.image,
                id: el._id,
                chars_left: this.state.maxChar - el.title.length
            })
        }
        else {
            this.setState({
                imageUrl: 'https://elite-skill-images.s3.ap-south-1.amazonaws.com/skills+6.png',
                image: 'https://elite-skill-images.s3.ap-south-1.amazonaws.com/skills+6.png'
            })
        }
        this.setState({
            edit: val,
            isAddTopic: true,
        })
    }

    handleModal = () => {
        this.setState({
            isAddTopic: false,
            nameError: '',
            imageError: '',
            name: '',
            image: '',
            imageUrl: '',
            maxChar: 75,
            chars_left: 75,
            isLoading: false
        })
    }

    changeName = (val) => {
        const charCount = val.length;
        const maxChar = this.state.maxChar;
        const charLength = maxChar - charCount;
        this.setState({
            name: val,
            nameError: '',
            chars_left: charLength
        })
    }

    changeImage = (e) => {
        if (e.target.files[0].size > 2097152) {
            this.setState({
                successMsg: true,
                successMessageText: "The file size cannot exceed 2MB",
            });
        } else {
            const file = this.refs.uploadImg.files[0];
            const reader = new FileReader();
            reader.onloadend = () => {
                this.setState({
                    imageUrl: reader.result,
                });
            };
            if (file) {
                reader.readAsDataURL(file);
                this.setState({
                    imageUrl: reader.result,
                    imageName: file.name,
                    image: file,
                    imageError: "",
                    update: true
                });
            } else {
                this.setState({
                    imageUrl: "",
                    imageName: "",
                    update: false
                });
            }
        }
    };

    saveSkillPod = async () => {
        if (this.state.name === "") {
            this.setState({
                nameError: "Please enter skillpod name",
            });
        } else if (this.state.image === '') {
            this.setState({
                imageError: 'Plesee upload image for skillpod'
            })
        }
        else {
            let obj = {
                name: this.state.name,
                image: this.state.image,
                _id: this.state.skillPathId
            }
            this.setState({
                isLoading: true
            })
            await this.props.savedSkillPod(obj);
            this.setState({
                isAddTopic: false,
                name: '',
                image: '',
                imageName: '',
                imageUrl: '/images/empty-image.svg',
                isLoading: false,
                update: false
            })
        }
    }


    updateSkillPod = async () => {
        if (this.state.name === "") {
            this.setState({
                nameError: "Please enter skillpod name",
            });
        } else if (this.state.image === '') {
            this.setState({
                imageError: 'Plesee upload image for skillpod'
            })
        }
        else {
            let obj = {}
            if (this.state.update) {
                obj = {
                    title: this.state.name,
                    image: this.state.image,
                    topic_id: this.state.id
                }
            }
            else {
                obj = {
                    title: this.state.name,
                    topic_id: this.state.id
                }
            }

            this.setState({
                isLoading: true
            })
            await this.props.updatedSkillPod(obj)
            if (this.props.successEnable) {
                this.setState({
                    isAddTopic: false,
                    name: '',
                    image: '',
                    imageName: '',
                    imageUrl: '/images/empty-image.svg',
                    isLoading: false,
                    update: false
                })
                this.props.getSkillPods(this.state.skillPathId);
            }
        }
    }

    handleChange = (id, checked) => {
        this.setState({
            checked: !checked
        }, () => {
            this.props.changeSkillPodStatus(id, this.state.skillPathId, checked)
        })
    }

    handleDragEnd = async (result) => {
        if (!result.destination) return
        await this.props.reorderSkillPods(result);
        await this.props.reorderedSkillPods(this.state.skillPathId, this.props.skillPods.map(el => [{ _id: el._id, index: el.index }][0]))
    }

    backtoBubble = () => {
        this.props.history.location.state.direct ? this.props.history.push('/manage-skills') : this.props.history.goBack();
    }

    goToSubTopics = (id, title, el) => {
        this.props.history.push({
            pathname: '/manage-skillpath/subtopics',
            state: { id: id, title: title, skill: this.props.history.location.state.skill, skillId: this.props.history.location.state.skillId, skillPathId: this.state.skillPathId, clone: this.props.skillPodDetails?.clone ?? true }
        })
        // this.props.hideSideBar()
    }
    snackClosed = () => {
        this.props.clearErrors();
        this.setState({
            successMsg: false,
            successMessageText: ''
        })
    }

    publishedSkillpath = async (id) => {
        await this.props.publishSkillpath(id);
        if (this.props.successEnable) {
            this.setState({
                draft: false
            })
        }
    }

    saveName = async () => {
        let obj = {
            _id: this.props.skillPodDetails?._id,
            title: this.state.skillPathTitle
        }
        await this.props.editSkillpath(obj);
        this.setState({
            isEdit: false
        })
    }

    render() {
        const { edit } = this.state
        const { skillPods, isSkillPodLoading, skillPodDetails, theme, successEnable, successMessage, successMessageText } = this.props

        return (
            <div className="manage-subjects">
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={successMessage}
                    onClose={() => this.snackClosed()}
                    message={successMessageText}
                    autoHideDuration={4000}
                />
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={successEnable}
                    onClose={() => this.snackClosed()}
                    message={successMessageText}
                    autoHideDuration={4000}
                />
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={this.state.successMsg}
                    onClose={() => this.snackClosed()}
                    message={this.state.successMessageText}
                    autoHideDuration={4000}
                />
                {
                    isSkillPodLoading ?
                        <TopicLoader /> :
                        <Fragment>
                            <div className='d-flex justify-content-between align-items-center' style={{ fontSize: 20, cursor: 'pointer' }}>
                                <div className='d-flex align-items-center' style={{ width: '45%' }}>
                                    <p style={{ marginTop: 6 }} onClick={() => this.backtoBubble()}>
                                        <img src='/images/back1.svg' alt='' width={24} />
                                    </p>&nbsp;&nbsp;
                                    <h1 className='d-flex align-items-center w-100' style={{ minHeight: 38 }}>
                                        {this.state.isEdit ?
                                            <input className='form-control' value={this.state.skillPathTitle} style={{ border: `1px solid ${theme?.bgColor}` }} onChange={(e) => this.setState({ skillPathTitle: e.target.value })} />
                                            : skillPodDetails?.title
                                        } &nbsp;
                                        {
                                            this.state.isEdit ?
                                                <div className='d-flex'>
                                                    <p style={{ fontSize: 12, color: theme?.bgColor }} onClick={() => this.saveName()}>Save</p>&nbsp;&nbsp;
                                                    <p style={{ fontSize: 12, color: theme?.bgColor }} onClick={() => this.setState({ isEdit: false })}>Cancel</p>
                                                </div>
                                                :
                                                <img src='/images/pencil-icon.svg' onClick={() => this.setState({ isEdit: true, skillPathTitle: skillPodDetails?.title })} alt='' />
                                        }
                                    </h1>
                                </div>
                                {
                                    (this.state?.draft == undefined || this.state?.draft === true) ?
                                        <div className='save-btn mt-0' >
                                            <button onClick={() => this.state.createSkillpath ? this.publishedSkillpath(this.state.skillPathId) : this.props.showWarning()}>Save & Publish</button>
                                        </div> :
                                        null
                                }
                            </div>
                            <Fragment>
                                <div className='upper-details'>
                                    <div>
                                        <img src={skillPodDetails?.image || '/images/sample.svg'} alt='' width='176px' height='120px' />
                                    </div>
                                    {skillPodDetails &&
                                        <Fragment>
                                            <div className='content-count'>
                                                {<img src='/images/topic-icon.svg' alt='' />}
                                                <p>{skillPodDetails?.topics}</p>
                                                <span>Topics</span>
                                            </div>
                                            {
                                                skillPodDetails?.articles !== 0 &&
                                                <div className='content-count'>
                                                    {<img src='/images/article-color-icon.svg' alt='' />}
                                                    <p>{skillPodDetails?.articles}</p>
                                                    <span>Articles</span>
                                                </div>
                                            }
                                            {skillPodDetails?.videos !== 0 &&
                                                <div className='content-count'>
                                                    {<img src='/images/video-color-icon.svg' alt='' />}
                                                    <p>{skillPodDetails?.videos}</p>
                                                    <span>Videos</span>
                                                </div>
                                            }
                                            {skillPodDetails?.documents !== 0 &&
                                                <div className='content-count'>
                                                    {<img src='/images/document-color-icon.svg' alt='' />}
                                                    <p>{skillPodDetails?.documents}</p>
                                                    <span>Documents</span>
                                                </div>
                                            }
                                            {skillPodDetails?.quizzes !== 0 &&
                                                <div className='content-count'>
                                                    {<img src='/images/quiz.svg' alt='' />}
                                                    <p>{skillPodDetails?.quizzes}</p>
                                                    <span>Quizzes</span>
                                                </div>
                                            }
                                        </Fragment>
                                    }
                                </div>
                            </Fragment>


                            <div className='subject-header'>
                                <div className='d-flex'>
                                    {skillPodDetails?.clone ?? true ? null : <button onClick={() => this.addTopic(null, false)}><img src='/images/plus-white.svg' alt='' /> &nbsp;&nbsp;&nbsp; Add Topic</button>}
                                </div>
                                <div className='content-heading'>
                                    <ul>
                                        <li>
                                            {<div>No.</div>}
                                            <div>Topics</div>
                                            <div>SubTopics</div>
                                            <div>Items</div>
                                            <div>Status</div>
                                            <div>Actions</div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            {
                                <DragDropContext onDragEnd={this.handleDragEnd}>
                                    <Droppable droppableId={this.state.skillPathId}>
                                        {
                                            (provided) => (
                                                <ul className='subject-list' {...provided.droppableProps} ref={provided.innerRef}>
                                                    {isSkillPodLoading ?
                                                        <div>
                                                            <TopicLoader />
                                                        </div> :
                                                        skillPods !== undefined && skillPods.length > 0 ?
                                                            skillPods.map((el, index) => {
                                                                return (
                                                                    <Draggable key={el._id} draggableId={el._id} index={index} >
                                                                        {
                                                                            (provided) => (
                                                                                <li {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef} onClick={() => this.goToSubTopics(el._id, el.title, el)}>
                                                                                    <div className='subject-num d-flex' onClick={(e) => {
                                                                                        e.preventDefault()
                                                                                        e.stopPropagation()
                                                                                    }} >
                                                                                        <img src='/images/drag.svg' alt='' />
                                                                                        {window.innerWidth > 767 && <p>{index + 1}</p>}
                                                                                    </div>
                                                                                    <div className='subject-name'>
                                                                                        <p style={{ width: '100%' }}>{el.title}</p>
                                                                                    </div>
                                                                                    <div className='text-center' >
                                                                                        <h3>{el.subtopic?.length ?? 0}</h3>
                                                                                    </div>
                                                                                    <div className='text-center'>
                                                                                        <h3>{el.items ?? 0}</h3>
                                                                                    </div>
                                                                                    <div className='text-center' >
                                                                                        <p onClick={(e) => {
                                                                                            e.preventDefault()
                                                                                            e.stopPropagation()
                                                                                            this.handleChange(el._id, el.active)
                                                                                        }}> <Switch
                                                                                                // onChange={() => this.handleChange(el._id, el.active)}
                                                                                                width={30}
                                                                                                height={16}
                                                                                                uncheckedIcon={false}
                                                                                                checkedIcon={false}
                                                                                                onColor='#00B24B'
                                                                                                checked={el.active} /><br />
                                                                                            {el.active ? 'Active' : 'Inactive'}</p>
                                                                                    </div>
                                                                                    <div className='text-center'>
                                                                                        <img src='/images/edit-pencil.svg' alt='' onClick={(e) => {
                                                                                            e.preventDefault()
                                                                                            e.stopPropagation()
                                                                                            this.addTopic(el, true)
                                                                                        }} /> &nbsp;&nbsp;
                                                                                    </div>
                                                                                </li>
                                                                            )
                                                                        }
                                                                    </Draggable>
                                                                )
                                                            })
                                                            : <div className='empty-list'>
                                                                <img src='/images/empty.png' alt='' />
                                                                <p>You have not added any Skillpods  yet.</p>
                                                            </div>
                                                    }
                                                    {provided.placeholder}
                                                </ul>
                                            )
                                        }
                                    </Droppable>
                                </DragDropContext>
                            }

                        </Fragment>
                }



                {/* ############## add and edit topic modal ############### */}
                <Modal
                    show={this.state.isAddTopic}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    dialogClassName={"add-topic-modal"}
                >
                    <div className="modal-header" style={{ background: theme?.bgColor }}>
                        <h5 className="modal-title">{edit ? 'Edit Topic' : 'Add Topic'} <br /><p>{skillPodDetails?.title}</p> </h5>

                        <div className="sticky-close" onClick={this.handleModal}>
                            <img src="/images/close-white.svg" width='15px' alt='' /></div>

                    </div>
                    <Modal.Body style={{ padding: '22px 40px 22px 40px', }}>

                        <div>
                            <label>Topic Name*
                                <aside className='float-right'>{this.state.chars_left}</aside>
                            </label>
                            <input className='form-control mt-2' value={this.state.name} maxLength={this.state.maxChar} onChange={(e) => this.changeName(e.target.value)} />
                        </div>
                        <small>{this.state.nameError}</small>
                        <div className='mt-4'>
                            <label>Topic Cover Image*</label>
                            <div className='d-flex align-items-center'>
                                {
                                    this.state.image ?
                                        <div className='program-image'>
                                            <img src={this.state.imageUrl} alt='' width='139px' height='78px' />
                                        </div> :
                                        <div className='program-image'>
                                            <img src={this.state.imageUrl} alt='' />
                                        </div>
                                }
                                <div className='d-flex flex-column  position-relative mt-3'>

                                    <span style={{ color: theme?.bgColor }}>
                                        <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9 3.828V15H7V3.828L3.757 7.071L2.343 5.657L8 0L13.657 5.657L12.243 7.071L9 3.828ZM1 17H15C15.2652 17 15.5196 17.1054 15.7071 17.2929C15.8946 17.4804 16 17.7348 16 18C16 18.2652 15.8946 18.5196 15.7071 18.7071C15.5196 18.8946 15.2652 19 15 19H1C0.734784 19 0.48043 18.8946 0.292893 18.7071C0.105357 18.5196 0 18.2652 0 18C0 17.7348 0.105357 17.4804 0.292893 17.2929C0.48043 17.1054 0.734784 17 1 17Z" fill={theme?.bgColor} />
                                        </svg>

                                        &nbsp;Upload Image &nbsp; <small>{this.state.imageName}</small>
                                        <input type='file' ref="uploadImg" className='file-upload'
                                            name="selectedFile" accept="image/png, image/jpeg,.doc" onChange={this.changeImage} />
                                    </span>
                                </div>
                            </div>
                        </div>
                        <small>{this.state.imageError}</small>
                        <div className='save-btn'>
                            {
                                edit ?
                                    <button onClick={this.updateSkillPod} style={{ backgroundColor: theme?.bgColor }} className='position-relative' >
                                        {this.state.isLoading ? <div className='ballbeat'><BallBeat color="#fff" /></div> : 'Save'}</button>
                                    :
                                    <button onClick={this.saveSkillPod} style={{ backgroundColor: theme?.bgColor }} className='position-relative'>
                                        {this.state.isLoading ? <div className='ballbeat'><BallBeat color="#fff" /></div> : 'Save'}</button>
                            }&nbsp;&nbsp;
                            <button onClick={this.handleModal}>Cancel</button>
                        </div>
                    </Modal.Body>
                </Modal>


                <WarningModal
                    planAlert={this.props.alert}
                    closeSubModal={this.props.closeSubModal}
                />
            </div >
        )
    }
}


export const mapStateToProps = (state) => {
    const { customPathId, skillPods, isSkillPodLoading, skillPodDetails } = state.manageSkillpath
    const { theme, plans, alert } = state.account
    const { successMessageText, successMessage, successEnable } = state.error
    return {
        customPathId, skillPods, isSkillPodLoading, skillPodDetails, theme, plans, alert,
        successMessageText, successMessage, successEnable
    }
}

export const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        publishSkillpath, editSkillpath, resetSKillpods, getSkillPodDetails, getSkillPods, savedSkillPod, updatedSkillPod, changeSkillPodStatus, reorderSkillPods, reorderedSkillPods,
        showWarning, closeSubModal, clearErrors
    }, dispatch)
}


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ManageTopic))
